import React, { useState, useEffect } from "react";
import Header from "components/navigation/Header";
import {
  Toolbar,
  Grid,
  Card,
  CardContent,
} from "@material-ui/core";
import { GlobalHeader } from "components/navigation/components/GlobalHeader";
import BreadcrumbsHeader from "components/navigation/BreadcrumbsHeader";
import Colors from "shared/color";
import { depositDetails, depositPaymentList } from "shared/api/deposit";
import { ROUTES_VAR } from "shared/constants";
import { Skeleton } from "@material-ui/lab";
import DepositDetails from "./components/DepositDetails";

// const components = {
//   RAZORPAY: RazorpayDetails,
//   CASH_PAID_STORE: CashInStoreDetails,
//   SETU: SetuDetails,
//   BANK_TRANSFER: BankDetails,
//   PROMOTIONAL: PromotionalDetails,
//   PAYTM: PaytmDetails,
//   CASH: CashDetails,
//   CHEQUE: ChequeDetails,
//   NACH: NachDetails,
// };

const DepositView = (props) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [depositPayments, setDepositPayments] = useState([]);

  const detailHandler = async () => {
    try {
      let search = props.match.params.id;
      let depositResopne = await depositDetails(search);
      setData(depositResopne);
      let depositPaymentResopne = await depositPaymentList(search);
      if (
        depositPaymentResopne.success &&
        depositPaymentResopne.data.payments.length
      ) {
        setDepositPayments(depositPaymentResopne.data.payments);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    detailHandler();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Header open={props.open}>
        <Toolbar
          style={{
            backgroundColor: Colors["AppBarBGPurple"],
            minHeight: "65px",
          }}
        >
          <GlobalHeader />
        </Toolbar>
        <Toolbar>
          <Grid container alignItems="center">
            <Grid item xs={12}>
              <BreadcrumbsHeader
                text={["Deposit table", "Deposit Details"]}
                links={[ROUTES_VAR.deposits]}
              />
            </Grid>
          </Grid>
        </Toolbar>
      </Header>
      <div className="common_padding_from_title">
        <div className="flex-spacing">
          {!loading && data.success ? (
            <DepositDetails
              data={data["data"]["deposit"]}
              setData={setData}
              depositPayments={depositPayments}
              Component={DepositDetails}
            />
          ) : !loading ? (
            <Card>
              <CardContent>No Payments Found</CardContent>
            </Card>
          ) : (
            <Skeleton
              animation="wave"
              variant="rect"
              width="100%"
              height={120}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default DepositView;
